module.exports = __webpack_public_path__ + "img/immediatelyConsult.e74419b6.jpg";